import { Box } from '@mui/material';
import styled from 'styled-components';

import { MenuPaper } from '@/shared/components/ui/paper/menu-paper/menu-paper';

export const ChatContainer = styled(Box)`
  && {
    position: absolute;
    bottom: 1rem;
    right: 1rem;
    z-index: 999;
    display: flex;
    flex-direction: column;
    align-items: flex-end;

    > * {
      z-index: 99999;
    }
  }
`;

export const ChatWindow = styled(MenuPaper)`
  && {
    width: 650px;
    margin-bottom: 0.5rem;
    padding: 1.25rem;
  }
`;
